// 선택된 잡의 최근 실행 이력(페이지네이션) - 표 안 펼침 행/카드 아래에 붙는다.
import React from 'react';
import {
  Box, Table, TableBody, TableCell, TableHead, TableRow, Chip, Typography,
  CircularProgress, Pagination, Stack,
} from '@mui/material';
import { statusMeta, formatDuration, formatDateTime } from '../../lib/sysJobUtils';

const TRIGGER_LABEL = { SCHEDULE: '스케줄', MANUAL: '수동', HOST: '호스트' };

const SysJobRunHistory = ({ runs, total, page, size, loading, onPageChange }) => {
  const pageCount = Math.max(1, Math.ceil((total || 0) / size));

  if (loading && (!runs || runs.length === 0)) {
    return (
      <Box sx={{ py: 2, textAlign: 'center' }}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (!runs || runs.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>
        실행 이력이 없습니다.
      </Typography>
    );
  }

  return (
    <Box sx={{ overflowX: 'auto' }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>시작</TableCell>
            <TableCell>트리거</TableCell>
            <TableCell>상태</TableCell>
            <TableCell>소요</TableCell>
            <TableCell>메시지</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {runs.map((run) => {
            const meta = statusMeta(run.status);
            return (
              <TableRow key={run.runId}>
                <TableCell>{formatDateTime(run.startDt)}</TableCell>
                <TableCell>{TRIGGER_LABEL[run.triggerTyp] || run.triggerTyp}</TableCell>
                <TableCell><Chip size="small" label={meta.label} color={meta.color} /></TableCell>
                <TableCell>{formatDuration(run.durationMs)}</TableCell>
                <TableCell sx={{ maxWidth: 320, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {run.message || '-'}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      {pageCount > 1 && (
        <Stack direction="row" justifyContent="center" sx={{ mt: 1 }}>
          <Pagination
            size="small"
            count={pageCount}
            page={page + 1}
            onChange={(_, p) => onPageChange(p - 1)}
          />
        </Stack>
      )}
    </Box>
  );
};

export default SysJobRunHistory;
